import React from 'react';
import AssetScanList from './components/AssetScanList';

const AssetScanListPage: React.FC = () => {
  // Title is set at the application level
  return <AssetScanList />;
};

export default AssetScanListPage;